/*
 * @Author: your name
 * @Date: 2022-03-10 13:26:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-06 23:15:47
 * @Description: file content
 */
export default [{
  path: '/bigWheel',
  name: 'BigWheel',
  component: () => import('@/views/LotteryTable/TurnTable'),
  meta: {
    roles: ['distributor', 'customer'],
  },
}, {
  path: '/luckyAward',
  name: 'LuckyAward',
  component: () => import('@/views/LotteryTable/LuckyDraw'),
  meta: {
    roles: ['distributor', 'customer'],
  },
}, {
  path: '/componenttest',
  name: 'ComponentTest',
  // 想要看的组件，需要在这里引入
  component: () => import('@/views/GoodsDetail/components/SwipeImgAndVideo.vue'),
  meta: {
    roles: ['distributor'],
  },
}]
